var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.getters.userIsAuthenticated)?_c('div',{staticClass:"router-page"},[_c('socialtabs',{attrs:{"context":"feed"}}),_vm._v(" "),_c('div',{staticClass:"items-feed"},[_c('items',{attrs:{"context":"feed"}})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }